var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackNeck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 19,
    viewBox: "0 0 43 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9861 0.512695C28.6583 2.58889 28.3305 4.77435 28.9861 8.05255C29.6417 11.3308 39.4763 12.642 42.0989 14.609C34.9961 17.5593 15.2177 19.8541 1.44922 14.609C4.72742 13.2977 12.9229 11.0029 13.5786 8.05255C14.2342 5.10217 13.4474 0.774951 12.9229 0.512695",
    stroke: "#202E5F",
    strokeWidth: 0.65564
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2012 0.84082C20.4628 2.80774 25.7079 0.84082 25.7079 0.84082",
    stroke: "#202E5F",
    strokeWidth: 0.65564,
    strokeDasharray: "1.31 1.31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackNeck);
export default __webpack_public_path__ + "static/media/BackNeck.100d1d437534bec8e342b3c461e1c9b5.svg";
export { ForwardRef as ReactComponent };